import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import numeral  from 'numeral';

import DataTable from '../../../components/DataTable';
import Page from '../../../components/Page';
import Panel from '../../../components/Panel';
import BlankState from '../../../components/BlankState';
import Utils from './../../../utils/mci-utils';



import { fetchPolicyClaimsCount, fetchPremiumTotals } from '../../../actions/dashboard';
import { fetchFilteredPolicies } from '../../../actions/policies';
import { listIntermediaries, listBankAgencies, listBrokers, listAgencies } from '../../../actions/brokers';


class Commissions extends Component{

	constructor(props){
		super(props);

		this.state = {
            commissions: [],
            user: {
                ...this.props.user
            },
            activeFilter: {},
            filter: {
                intermediary : ''
            },
            policies_loading : true,
        };
	}

	componentDidMount() {
        let insurer = this.state.user.userInfo.insurer
        const { fetchPolicyClaimsCount, fetchPremiumTotals, fetchFilteredPolicies, listIntermediaries, listBankAgencies, listBrokers, listAgencies } = this.props;

        fetchPolicyClaimsCount(insurer);
        fetchPremiumTotals(insurer);
        fetchFilteredPolicies();
        listIntermediaries();
        listBankAgencies();
        listAgencies();
        listBrokers();
        
    }

    getIntermediaries(){
		const { fetchFilteredPolicies } = this.props;

        fetchFilteredPolicies(this.state.filter);
	}

    selectFilterType = (e) => {
        this.setState({
            activeFilter: e.target.value
        });
    }

    onChangeFilter = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        const { filter } = this.state;
    
        this.setState({
            filter: {
                ...this.state.filter,
                [name] : value
            },
        }, ()=>{
            this.getIntermediaries();
        });
    }
    
	render(){
        const { dashboard, policies, brokers } = this.props;
        const {  activeFilter } = this.state;

        let allPremiums = dashboard.premium.premiums ? dashboard.premium.premiums.this_year : null;

		return(
            <Page isAdminPage={ true } pageTitle="Commissions">
                <div className="row stats-row">
                    <div className="col-sm-3">
                        <div className="card">
                            <span>Total Policies</span>
                            <h4>{ dashboard.policy_count.this_year }</h4>
                        </div>
                    </div>
                    <div className="col-sm-5">
                        <div className="card">
                            <span>Total Premiums (TSh.)</span>
                            <h4>{ numeral(allPremiums).format('0,0.00') }</h4>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="card">
                            <span>Total Commisions (TSh.)</span>
                            <h4>{ numeral(dashboard.commissions.all_commisions).format('0,0.00') }</h4>
                        </div>
                    </div>
                </div>
                <div className="row stats-row">
                    <div className="col-sm-3">
                        <div className="card">
                            <span>Today</span>
                            <h4>{ numeral(dashboard.commissions.today).format('0,0.00') }</h4>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="card">
                            <span>This Week (TSh.)</span>
                            <h4>{ numeral(dashboard.commissions.this_week).format('0,0.00') }</h4>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="card">
                            <span>This Month (TSh.)</span>
                            <h4>{ numeral(dashboard.commissions.this_month).format('0,0.00') }</h4>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="card">
                            <span>This Year (TSh.)</span>
                            <h4>{ numeral(dashboard.commissions.this_year).format('0,0.00') }</h4>
                        </div>
                    </div>
                </div>

                <Panel title="Commisions">
                    <form className="form-inline filter-form row clearfix">
                        <div className="col-sm-4 col-md-3">
                            <select 
                                name="filter" 
                                className="form-control"
                                onChange={ this.selectFilterType }>

                                <option value="">- Filter by -</option>
                                <option value="brokerage">BROKER</option>
                                <option value="agency">AGENCY</option>
                                <option value="bank_agency">BANK AGENCY</option>
                            </select>
                        </div>
                        <div  className="col-sm-6 col-md-4">
                            {
                                activeFilter === 'brokerage' ?

                                    <select 
                                        name="intermediary" 
                                        className="form-control"
                                        onChange={ this.onChangeFilter }>

                                        <option value="" >- Select a Broker -</option>
                                        {
                                            brokers.brokers.map((broker, index)=>{
                                                return(
                                                    <option key={ index } value={ broker.id }>
                                                        { broker.name }
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                : null
                            }
                            {
                                activeFilter === 'agency' ?

                                    <select 
                                        name="intermediary" 
                                        className="form-control"
                                        onChange={ this.onChangeFilter }>

                                        <option value="">- Select an Agent -</option>
                                        {
                                            brokers.agencies.map((agency, index)=>{
                                                return(
                                                    <option key={ index } value={ agency.id }>
                                                        { agency.name }
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                : null
                            }
                            {
                                activeFilter === 'bank_agency' ?

                                    <select 
                                        name="intermediary" 
                                        className="form-control"
                                        onChange={ this.onChangeFilter }>

                                        <option value="">- Select a Bank Agent -</option>
                                        {
                                            brokers.bank_agencies.map((bank, index)=>{
                                                return(
                                                    <option key={ index } value={ bank.id }>
                                                        { bank.name }
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                : null
                            }
                        </div>
                    </form>
                    &nbsp;

                    <hr/>

                    <div className="clearfix">
                    
                    {
                        policies.filteredPolicies.length > 0 ?

                        <DataTable 
                            tableId="commisions-table"
                            columnTitles={ ["Policy No.", "Policy Holder", "Intermediary", "Sum Insured", "Gross Direct Premium", "Premium"] }>

                            {
                                policies.filteredPolicies.map((commission, index)=>{
                                    return(
                                        <tr key={ index } >
                                            <td> {commission.policy_number }</td>
                                            <td>{ commission.proposer_name }</td>
                                            <td>{ commission.intermediary ? commission.intermediary_name : '--' }</td>
                                            <td>{ Utils.parseAmount(commission.total_sum_insured) }</td>
                                            <td>{ Utils.parseAmount(commission.gross_direct_premium) }</td>
                                            <td>{ Utils.parseAmount(commission.premium) }</td>
                                        </tr>
                                    )
                                })
                            }
                        </DataTable>
                    :
                    <BlankState 
                    data={ policies.filteredPolicies } 
                    dataName="Policies" 
                    isDataLoading={ policies.policies_loading } />
                    }
                    </div>
                </Panel>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    dashboard: state.dashboard,
    policies: state.policies,
    brokers: state.brokers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ fetchPolicyClaimsCount, fetchPremiumTotals, fetchFilteredPolicies, listIntermediaries, listBankAgencies, listBrokers, listAgencies }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Commissions);


// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/Commissions.jsx